export const SetSpaceQueryService = Symbol('SetSpaceQueryService');
export const GetSpaceQueryService = Symbol('GetSpaceQueryService');
